import { render, staticRenderFns } from "./CatalogoDialogMenu.vue?vue&type=template&id=4a4ca620"
import script from "./CatalogoDialogMenu.vue?vue&type=script&lang=js"
export * from "./CatalogoDialogMenu.vue?vue&type=script&lang=js"
import style0 from "./CatalogoDialogMenu.vue?vue&type=style&index=0&id=4a4ca620&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports